import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getTodaysEvents = createAsyncThunk(
	'getTodaysEvents',
	async () => await envAwarePost('api/events/api/',{
		action:'getTodaysEvents',
		normalize:1,
		include_event_items:1
	})
)

export const updateEvent = createAsyncThunk(
	'updateEvent',
	async payload => await envAwarePost('api/events/api.php',{
		action:'updateEvent',
		...payload
	})
)

export const updateNutrtionSimplifiedFood = createAsyncThunk(
	'updateNutrtionSimplifiedFood',
	async payload => await envAwarePost('api/events/api/',{
		action:'updateNutritionSimplifiedFood',
		...payload
	})
)

//set up adapters
const selectId = entity=>entity.event_id
const workoutsAdapter = createEntityAdapter({selectId})
const tasksAdapter = createEntityAdapter({selectId})
const nutritionAdapter = createEntityAdapter({selectId})

//get events inital state from adapters
const workoutsInitialState = workoutsAdapter.getInitialState({
	userSelected:null,
})
const tasksInitialState = tasksAdapter.getInitialState({
	userSelected:null
})
const nutritionInitialState = nutritionAdapter.getInitialState({
	userSelected:null
})

const todaysEventsSlice = createSlice({
	name: 'todaysEvents',
	initialState:{
		status:'init',
		workout:workoutsInitialState,
		task:tasksInitialState,
		nutrition:nutritionInitialState
	},
	reducers: {
		eventSelectedByUser:(state,action)=>{
			const {type,id} = action.payload
			state[type].userSelected = id
		},
		addNutrition:(state,action)=>{
			const {id,data} = action.payload
			state.nutrition.entities[id] = data
		},
		replaceEventData:(state,action)=>{
			const {event,event_type} = action.payload
			if(Boolean(event)){
				state[event_type].entities[event.event_id] = event
			}
			
		}
	},
	extraReducers:{
		/* -- get todays events -- */
		[getTodaysEvents.pending]:state=>{state.status='pending'},
		[getTodaysEvents.fulfilled]:(state,action)=>{
			const {payload} = action
			if(payload.success == 1){
				state.status='ready'
				const {workout,task,nutrition} = payload.data
				workoutsAdapter.setAll(state.workout,workout)
				tasksAdapter.setAll(state.task,task)
				nutritionAdapter.setAll(state.nutrition,nutrition)
			}else{
				state.status='failed'
			}
		},
		[getTodaysEvents.rejected]:(state,action)=>{
			state.status='failed'
			console.log(action)
		},	
		/* -- update event -- */
		[updateEvent.pending]:(state,action)=>{
			const {event_type,event_id,complete} = action.meta.arg
			state[event_type].entities[event_id].complete = complete
			//to prevent moving to the next relevant event set this event
			//as user seleted
			state[event_type].userSelected = event_id
		},
		[updateEvent.fulfilled]:(state,action)=>{
			//do nothing
		},
		[updateEvent.rejected]:(state,action)=>{
			console.log(action.payload)
		},
		
	}
})

export const {eventSelectedByUser,replaceEventData} = todaysEventsSlice.actions

//selectors

export const getEventCompleteStatus = (event,id) => state =>(
	state.todaysEvents[event].entities[id].complete
)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllWorkouts,
	selectById: selectWorkoutById,
	selectIds: selectWorkoutIds
} = workoutsAdapter.getSelectors(state => state.todaysEvents.workout)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllTasks,
	selectById: selectTaskById,
	selectIds: selectTaskIds
} = tasksAdapter.getSelectors(state => state.todaysEvents.task)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllNutrition,
	selectById: selectNutritionById,
	selectIds: selectNutritionIds
} = nutritionAdapter.getSelectors(state => state.todaysEvents.nutrition)

export const getRelevantEvents = event => state => Object.values(state.todaysEvents[event].entities)


export default todaysEventsSlice.reducer